import { render, staticRenderFns } from "./commonFoot.vue?vue&type=template&id=91344dba&scoped=true&"
import script from "./commonFoot.vue?vue&type=script&lang=js&"
export * from "./commonFoot.vue?vue&type=script&lang=js&"
import style0 from "./commonFoot.vue?vue&type=style&index=0&id=91344dba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91344dba",
  null
  
)

export default component.exports